import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/ipoteka"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0725 0.358053L9.53175 0.0158688L8.9945 0.363496L2.99729 4.24404L0 6.1569L1.07592 7.84278L2.53791 6.90975V15.9996H4.53786V5.62932L9.54374 2.39022L15.0029 5.84488L16.0723 4.1549L10.0725 0.358053ZM14.5376 15.9996C15.366 15.9996 16.0376 15.328 16.0376 14.4996C16.0376 13.6712 15.366 12.9996 14.5376 12.9996C13.7092 12.9996 13.0377 13.6712 13.0377 14.4996C13.0377 15.328 13.7092 15.9996 14.5376 15.9996ZM10.0377 8.49974C10.0377 9.32815 9.36617 9.99971 8.53777 9.99971C7.70936 9.99971 7.0378 9.32815 7.0378 8.49974C7.0378 7.67134 7.70936 6.99978 8.53777 6.99978C9.36617 6.99978 10.0377 7.67134 10.0377 8.49974ZM14.3023 7.12214L7.36954 14.6446L8.84019 16L15.7729 8.4775L14.3023 7.12214Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Ipoteka16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Ipoteka16 = createIcon(IconComponent);